import 'core-js';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';

import '../Theme/lib/bootstrapThemed.scss';
import 'rc-slider/assets/index.css';

import '../Theme/_styles.scss';

// Support component names relative to this directory:
const componentRequireContext = require.context('components', true);
const ReactRailsUJS = require('react_ujs');
// eslint-disable-next-line react-hooks/rules-of-hooks
ReactRailsUJS.useContext(componentRequireContext);
